var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-onboarding-provider mx-auto ov-hidden" },
    [
      _c(
        "header",
        { staticClass: "acenter" },
        [
          _vm._t("subtitle", [
            _c("p", { staticClass: "subtitle lh-20 fs-3 m-0" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Pour profiter pleinement de vos emails dans Sellsy, sélectionnez le service que vous utilisez pour vos emails : "
                    )
                  ) +
                  "\n            "
              )
            ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-row flex-bottom jc-space w-5 mx-auto mt-4" },
        _vm._l(_vm.providers, function(ref) {
          var id = ref.id
          var title = ref.title
          var icon = ref.icon
          return _c(
            "div",
            {
              key: id,
              staticClass:
                "provider-item flex-row flex-bottom pb-3 jc-center b-1 br cpointer white-bkg",
              class: { "b-1-primary-50": _vm.isFocus(id) },
              attrs: { id: "select-email-provider-" + id },
              on: {
                click: function($event) {
                  return _vm.onValidateProvider(id, title)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "flex-column ai-center ov-hidden" },
                [
                  _c("SaasIcon", {
                    attrs: { icon: icon, width: "35", height: "35" }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "mb-0 mt-1 semibold" }, [
                    _vm._v(_vm._s(title))
                  ])
                ],
                1
              )
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("p", { staticClass: "description fs-2 gray-60 acenter mb-0 mt-3" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Si vous avez un doute sur votre service, demandez à votre administrateur."
              )
            ) +
            "\n    "
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }